import { useEffect, useState } from "react";
// @mui material components
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
// Acromegaly React components
import MDBox from "components/MDBox";
import Swal from "sweetalert2";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// Acromegaly React example components

import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import getText from "Translator";
import { displayErrorMessage } from "controllers/validation";
import { updatePermission } from "controllers/UserController";
import { getUser } from "controllers/UserController";
import { getAllTitleAndCapsules } from "controllers/MenuController";
import { useMaterialUIController } from "context";
import { TreeItem, TreeView } from "@mui/lab";

let data = {};

let userId = "";
let user;
const UserPermission = (props) => {
  const [controller] = useMaterialUIController();
  const [selectedNodes, setSelectedNodes] = useState([]);

  const [initialValues, setInitialValues] = useState([]);
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [relaod, setReload] = useState(new Date());
  const [userRole, setUserRole] = useState("user");
  useEffect(() => {
    userId = props.userId;

    getData();
  }, []);
  const getData = async () => {
    setLoading(true);
    let result = await getAllTitleAndCapsules(controller.token);
    if (result.success) {
      data = result.data;
      setDatas(data.children);
      getUserData();
    } else {
      displayErrorMessage(result.message);
    }
    setLoading(false);
  };
  const handleChangeUserRole = (event) => {
    setUserRole(event.target.value);
  };
  const getUserData = async () => {
    let result = await getUser("fa", userId, controller.token);

    if (result.success) {
      user = result.data;
      console.log("useruser", user);
      setInitialValues(user.permission);
      setUserRole(user.userRole);
    } else {
      displayErrorMessage(result.message);
    }
    setLoading(false);
  };
  const submitHandler = async () => {
    let body = {
      permission: initialValues,
      userRole: userRole,
      id: userId,
    };
   
    let data = await updatePermission(controller.lang, body, controller.token);
    if (data.success) {
      Swal.fire({
        text: data.message,
        position: "top-end",
        icon: "success",
        showConfirmButton: false,
        timer: 1500,
      });
      props.handleClose();
    } else {
      if (data.errorCode === 101) {
        props.history.replace("/");
      } else {
        displayErrorMessage(data.message);
      }
    }
  };
  const renderTree = (nodes, onSelect) =>
    nodes.type.toLowerCase() === "clinick" ? (
      <FormControlLabel
        style={{ color: "#4a4a4a", fontSize: 13 }}
        control={
          <Checkbox
            className={"clinickChb"}
            name="clinick"
            checked={initialValues.indexOf(nodes.id) !== -1}
            onChange={(e) => {
              let dd = initialValues;
              if (!e.target.checked) {
                dd.splice(initialValues.indexOf(nodes.id), 1);
              } else {
                dd.push(nodes.id);
              }
              setInitialValues(dd);
              setReload(new Date());
              // onSelect(nodes.id, e.target.checked);
            }}
          />
        }
        label={nodes.name}
        key={nodes.id}
      />
    ) : (
      <TreeItem
        key={nodes.id}
        nodeId={nodes.id}
        label={
          <div>
            {nodes.type === "root" ? (
              <>{nodes.name}</>
            ) : nodes.type === "headline" ? (
              <>{nodes.name}</>
            ) : nodes.type === "title" ? (
              <>{nodes.name}</>
            ) : null}
          </div>
        }
        onIconClick={() => {
          //onSelect(nodes.type, nodes.name);
        }}
      >
        {Array.isArray(nodes.children)
          ? nodes.children.map((node) => renderTree(node, onSelect))
          : null}
      </TreeItem>
    );

  return (
    <MDBox pb={3} style={{ minWidth: 500 }}>
      <RadioGroup
        aria-label="role"
        name="role"
        value={userRole}
        onChange={handleChangeUserRole}
      >
        <Grid container>
          <Grid item xs={12} sm={5} md={5}>
            <FormControlLabel
              value="admin"
              control={<Radio />}
              label={getText("changepermissiontoadmin", controller.lang)}
            />
          </Grid>
          <Grid item xs={12} sm={5} md={5}>
            <FormControlLabel
              value="user"
              control={<Radio />}
              label={getText("changepermissiontouser", controller.lang)}
            />
          </Grid>
          <Grid item xs={12} sm={2} md={2}>
            <Button fullWidth onClick={submitHandler} color="secondary">
              {getText("submit", controller.lang)}
            </Button>
          </Grid>
        </Grid>
      </RadioGroup>

      <div className="root" initialValues={initialValues}>
        {datas && (
          <TreeView
            multiSelect
            defaultCollapseIcon={<ExpandMoreIcon />}
            defaultExpandIcon={<ChevronRightIcon />}
            selected={selectedNodes}
          >
            {datas.map((node) => renderTree(node))}
          </TreeView>
        )}
      </div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Button fullWidth onClick={submitHandler} color="secondary">
            {getText("submit", controller.lang)}
          </Button>
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default UserPermission;

const Tree = (props) => {
  return (
    <>
      {/* <TreeView
        defaultCollapseIcon={<ExpandMoreIcon style={{ fontSize: 24 }} />}
        defaultExpanded={["root"]}
        defaultExpandIcon={<ChevronRightIcon style={{ fontSize: 24 }} />}
        multiSelect
      >
        {props.renderTree(props.data, props.setFieldValue)}
      </TreeView> */}
    </>
  );
};
